import { Tag, Tooltip } from 'antd';
import cx from 'classnames';
import React from 'react';
import './Tag.scss';

const CustomTag = (props) => {
  const {
    className,
    text,
    isAddHash = true,
    isShowToolTip,
    toolTipPlacement = 'bottom',
    toolTipTitle = '비활성 태그',
    ...res
  } = props;

  if (!text) return null;

  return (
    <Tooltip placement={isShowToolTip ? toolTipPlacement : undefined} title={isShowToolTip ? toolTipTitle : undefined}>
      <Tag className={cx('amondz-tag', className)} {...res}>
        {isAddHash ? '#' : null}
        {text}
      </Tag>
    </Tooltip>
  );
};

export default CustomTag;
